import React, { useState, useContext } from "react";
import Grid from "@mui/material/Grid";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthProvider";
import { useTranslation } from "react-i18next";
import AuthLayout from "../../components/AuthLayout";
import bgImage from "../../images/main-bg.jpg";
import "./style.scss";
import { useLang } from "../../context/LangContext";
const arabicMessages = {
  required: "الحقل مطلوب",
  email: "يرجى إدخال بريد إلكتروني صالح",
  phone: "يرجى إدخال رقم هاتف صالح",
  numeric: "يجب أن يكون الحقل رقمًا",
  password: "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
  otp : "يرجى إدخال رمز التحقق"
};


const LoginPage = () => {
  const { t } = useTranslation();
  const { lang } = useLang();
  const { logIn, loginWithPhone, verifyPhone } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loginMethod, setLoginMethod] = useState("phone"); // "email" or "phone"
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const [value, setValue] = useState({
    email: "",
    password: "",
    phone: "",
    otp: "",
    remember: false,
  });

  const changeHandler = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
    validator.showMessages();
  };

  const rememberHandler = () => {
    setValue({ ...value, remember: !value.remember });
  };

  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
      messages: lang === "ar" ? arabicMessages : undefined,
    })
  );


  const submitForm = async (e) => {
    e.preventDefault();
    //  if (!validator.allValid()) {
    //     validator.showMessages();
    //     toast.error('Please fill in all required fields correctly.');
    //     return;
    // }
    try {
      setLoading(true);
      if (loginMethod === "email") {
        await logIn(value.email, value.password);
        toast.success(t(`LoginSuccessful`));
        navigate("/");

      } else {
        const response = await loginWithPhone(value.phone);
        if (response.success) {
          toast.success(t(`OTPSent`));
          setOtpSent(true);
          return;
        }
      }
    } catch (error) {
      toast.error(t(`LoginFailed`));
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!value.phone) {
      toast.error(t(`PhoneRequired`));
      return;
    }
    try {
      setLoading(true);
      await verifyPhone(value.phone, value.otp);
      toast.success(t(`LoginSuccessful`));
      navigate("/");
    } catch (error) {
      toast.error(t(`LoginFailed`));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout image={bgImage}>
    <Grid className="loginWrapper" dir={lang === "ar" ? "rtl" : "ltr"}>
      <Grid className="loginForm">
        <h2>{t(`login`)}</h2>
        <p>{t(`loginDesc`)}</p>
        <div className="loginToggle">
          <Button
            onClick={() => setLoginMethod("email")}
            disabled={loginMethod === "email"}
          >
            {t(`emailAndPassword`)}
          </Button>
          <Button
            onClick={() => setLoginMethod("phone")}
            disabled={loginMethod === "phone"}
          >
            {t(`phone`)}
          </Button>
        </div>
        <form onSubmit={submitForm}>
          <Grid container spacing={3}>
            {loginMethod === "email" ? (
              <>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={t(`email`)}
                    name="email"
                    value={value.email}
                    onChange={changeHandler}
                    variant="outlined"
                  />
                  {validator.message("email", value.email, "required|email")}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={t(`password`)}
                    type="password"
                    name="password"
                    value={value.password}
                    onChange={changeHandler}
                    variant="outlined"
                  />
                  {validator.message("password", value.password, "required|password")}
                </Grid>
              </>
            ) : !otpSent ? (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t(`phone`)}
                  name="phone"
                  value={value.phone}
                  onChange={changeHandler}
                  variant="outlined"
                      dir="ltr"
                />
                {validator.message("phone", value.phone, "required|phone")}
              </Grid>
            ) : (
              loginMethod === "phone" &&
              otpSent && (
                <>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label={t(`otp`)}
                      name="otp"
                      value={value.otp}
                      onChange={changeHandler}
                      variant="outlined"
                      dir="ltr"
                    />
                    {validator.message("otp", value.otp, "required|numeric")}
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      onClick={handleVerifyOtp}
                      disabled={loading}
                    >
                     {t(`verifyOtp`)}
                    </Button>
                  </Grid>
                </>
              )
            )}

            <Grid item xs={12}>
              <Grid className="formAction">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={value.remember}
                      onChange={rememberHandler}
                    />
                  }
                  label={t(`rememberMe`)}
                />
                <Link to="/forgot">{t(`forgot`)}</Link>
              </Grid>
              {!otpSent && (
                <Grid className="formFooter">
                  <Button fullWidth type="submit" disabled={loading}>
                    {t(`login`)}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </form>
        <p className="noteHelp">
          {t(`noAccount`)}{" "}<Link to="/register">{t(`register`)}</Link>
        </p>
      </Grid>
    </Grid>
    </AuthLayout>
  );
};

export default LoginPage;
